<template>
    <div class="payment-failure-container">
      <div class="failure-box">
        <img
          src="../assets/payment_failed.png"
          alt="Ошибка оплаты"
          class="failure-icon"
        />
  
        <h2 class="failure-title">Оплата не завершена</h2>
  
        <p class="failure-text">
          Платёж был отменён или произошла ошибка.<br />
          Вы можете попробовать снова или вернуться в премиум-раздел.
        </p>
  
        <button class="back-button" @click="goToPremium">
          Вернуться в премиум
        </button>
      </div>
    </div>
  </template>

<script setup>

import { useRouter } from "vue-router";

const router = useRouter();
const goToPremium = () => {
  router.push("/premium");
};

</script>

<style scoped>

.payment-failure-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #161616;
}

.failure-box {
  background-color: #2b2b2b;
  padding: 32px;
  border-radius: 12px;
  text-align: center;
  width: 360px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}

.failure-icon {
  width: 90px;
  margin-bottom: 16px;
}

.failure-title {
  font-size: 22px;
  font-family: "Eastman-Bold", sans-serif;
  color: #ffffff;
  margin-bottom: 12px;
}

.failure-text {
  font-size: 14px;
  font-family: "Eastman-Regular", sans-serif;
  color: #cccccc;
  line-height: 1.5;
  margin-bottom: 20px;
}

.back-button {
  background: #ffffff;
  color: #000000;
  border: none;
  padding: 12px 20px;
  font-size: 14px;
  font-family: "Eastman-Medium", sans-serif;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.back-button:hover {
  background: #f0f0f0;
}

</style>